export default function checkRating(ratingThresholds, subject, score, ratingTest) {
  const ratings = ratingThresholds[subject]
  let rating = 1, ratingFound = false
  ratings.forEach(function seeIfRatingApplies(r) {
    if (!ratingFound && ratingTest(r, score)) {
      ratingFound = true
      rating = r.rating
    }
  })
  return rating
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/checkRating.js